'use client';
import { createContext, useContext, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import { toast } from 'react-toastify';
import { useUser } from '@/services/contexts/UserContext';
import { BACKEND_URL } from '@/lib/api';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const [notifications, setNotifications] = useState<any[]>([]);
  const { user } = useUser();

  useEffect(() => {
    if (!user?.id) return;

    const socket = io(`${BACKEND_URL}/notifications`, {
      transports: ["websocket"],
      withCredentials: true,
    });

    socket.on('notification', (payload) => {
      setNotifications(prev => [payload, ...prev]);
      toast.success(payload.message);
    });

    return () => {
      socket.disconnect();
    };
  }, [user?.id]);


  return (
    <NotificationContext.Provider value={{ notifications, setNotifications }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationContext);
